import {
  ChartCategoryAxisItemProps,
  ChartValueAxisItemProps,
} from "@progress/kendo-react-charts";

/**
 * Default styling configuration for chart axes
 * Uses CSS custom properties for consistent theming
 */
export const defaultAxisStyling = {
  labels: {
    color: "var(--ghost-color)",
  },
  line: {
    color: "var(--muted-bg-color)",
  },
  majorGridLines: {
    color: "var(--muted-bg-color)",
  },
} as const;

/**
 * Default category axis configuration with consistent styling
 * @param categories - Array of category labels (required for ChartCategoryAxisItem)
 * @param overrides - Optional overrides for specific properties
 */
export const getDefaultCategoryAxisProps = (
  categories: string[],
  overrides?: Partial<ChartCategoryAxisItemProps>
): ChartCategoryAxisItemProps => ({
  categories,
  labels: defaultAxisStyling.labels,
  line: defaultAxisStyling.line,
  majorGridLines: defaultAxisStyling.majorGridLines,
  ...overrides,
});

/**
 * Default category axis configuration without categories (for when you want to set categories separately)
 * Useful when you need to pass categories from a different source
 */
export const getDefaultCategoryAxisStyling = (
  overrides?: Partial<ChartCategoryAxisItemProps>
): Omit<ChartCategoryAxisItemProps, "categories"> => ({
  labels: defaultAxisStyling.labels,
  line: defaultAxisStyling.line,
  majorGridLines: defaultAxisStyling.majorGridLines,
  ...overrides,
});

/**
 * Default value axis configuration with consistent styling
 */
export const getDefaultValueAxisProps = (
  overrides?: Partial<ChartValueAxisItemProps>
): ChartValueAxisItemProps => ({
  labels: defaultAxisStyling.labels,
  line: defaultAxisStyling.line,
  majorGridLines: defaultAxisStyling.majorGridLines,
  ...overrides,
});
